document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".header-search-control");
  const btnClose = document.querySelector(".header-search-bar-close");
  const bar = document.querySelector(".header-search-bar");

  if (!btn || !bar || !btnClose) return;

  btn.addEventListener("click", (e) => {
    e.preventDefault();
    bar.classList.toggle("active");
  });

  btnClose.addEventListener("click", (e) => {
    bar.classList.remove("active");
  });
});
